import PlayerModel from './PlayerModel'

export default (notification) => {
  if (!notification) return

  if (notification.sender.player) {
    notification.sender.player = PlayerModel(notification.sender.player)
  }

  return Object.defineProperties(notification, {})
}



// WEBPACK FOOTER //
// ./src/services/Models/NotificationModel.js